import {
  ReadVPNExcelFileType,
  VPNQueryBody,
  IncomingVpnAttendanceList,
} from '../../../../types/TimeAndAttendance/VpnAttendance/VpnAttendanceTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, vpnAttendanceApiConfig } from '../../apiList'

//used to upload data to the API using the excel file as the input
const readExcelFile = async (
  file: FormData,
): Promise<ReadVPNExcelFileType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: vpnAttendanceApiConfig.readVPNExcelFile,
    method: AllowedHttpMethods.post,
    data: file,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getVPNAttendance = async (
  props: VPNQueryBody,
): Promise<IncomingVpnAttendanceList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: vpnAttendanceApiConfig.getVPNAttendnace,
    method: AllowedHttpMethods.get,
    params: {
      dateSelection: props.dateSelection,
      endIndex: props.endIndex ?? 20,
      from: props.from,
      search: props.search,
      startIndex: props.startIndex ?? 0,
      to: props.to,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const VPNAttendanceApi = {
  getVPNAttendance,
  readExcelFile,
}

export default VPNAttendanceApi
